import { BaseProxy } from "@/proxies/BaseProxy";

export class TasksProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `tasks`,
      parameters,
    });
  }
}
